import React, { useEffect, useState } from "react"
import Page from "../../common/page/Page"
import Form from "../../common/form/Form"
import LoginIcon from "../../icons/LoginIcon"
import { Link, useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { useAuth } from "../../data/useAuth"
import Loader from "../../common/loader/Loader"
import styles from "../../common/form/form.module.css"

const Login = () => {
  const { signIn, isLoggedIn, user } = useAuth()
  const navigator = useNavigate()
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  // const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    if (!formData.email || !formData.password) {
      setError("Both fields are required.")
      return
    }

    try {
      setLoading(true)
      // const response = await axios.post("api/auth/login", {
      //   email: formData.email,
      //   password: formData.password,
      // })

      // // console.log("Login successful:", response.data)
      // signIn(response.data.user)
      axios.defaults.withCredentials = true
      await axios
        .post(
          "api/auth/login",
          {
            email: formData.email,
            password: formData.password,
          },
          { withCredentials: true }
        ) // include cookies
        .then(async () => {
          const res = await axios.get("api/auth/me", { withCredentials: true })
          signIn(res.data.user)
          navigator("/")
          setFormData({ email: "", password: "" })
        })
      navigator("/")
      setFormData({
        email: "",
        password: "",
      })
      // Redirect to dashboard or home page
      // navigate("/dashboard")
    } catch (err) {
      console.error("Login error:", err)
      if (err.response) {
        setError(err.response.data.error || "Login failed.")
      } else {
        setError("Network error, please try again.")
      }
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  return (
    <Page title={"Welcome Back"} searchDisabled={true}>
      {loading ? (
        <div style={{ display: "flex", height: "calc(80vh - 100px)" }}>
          <Loader />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <div className={styles.cardContainer}>
            <div className={styles.cardHeader}>
              <h2>Welcome Back</h2>
              <p>Sign in to manage your orders & account</p>
              <div className={styles.quote}>
                "Self-care is not a luxury, it is a daily necessity."
              </div>
            </div>

            <div>
              <label htmlFor="login_email">Email Address</label>
              <input
                type="email"
                id="login_email"
                name="email"
                placeholder="name@example.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="login_password">Password</label>
              <input
                type="password"
                id="login_password"
                name="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            {error && <div className={styles.errorBanner}>{error}</div>}

            <div>
              <button type="submit">
                Sign In <LoginIcon />
              </button>
            </div>

            <div className={styles.linkBox}>
              <p>
                <Link to={"/forgot-password"}>Forgot password?</Link>
              </p>
              <p>
                Don't have an account? <Link to={"/sign-up"}>Create Account</Link>
              </p>
            </div>
          </div>
        </Form>
      )}
    </Page>
  )
}

export default Login
